import React from "react";
import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";

import { apiPath } from "../../utility/Constant";
import { useParams } from "react-router-dom";

const ClientUniqueReview = () => {
  const { clientsReviewApi } = apiPath;
  const clientId = useParams();
  const [clients, clientsLoading] = useFetch(clientsReviewApi, true);

  if (clientsLoading) {
    return <Loading />;
  }
  const filteredData = clients.filter((item) => item._id === clientId.id)[0];

  const { designation, featured, img, message, name, title, _id } =
    filteredData;

  const data = [
    {
      elementType: "textField",
      label: "Review Title",
      type: "Text",
      name: "title",
      defaultValue: title,
      required: true,
    },
    {
      elementType: "textField",
      label: "Review",
      type: "Text",
      name: "message",
      defaultValue: message,
      required: true,
    },
    {
      elementType: "file",
      label: "Client Image",
      type: "Text",
      name: "img",
      defaultValue: img,
      required: true,
    },
    {
      elementType: "textField",
      label: "Client Name",
      type: "Text",
      name: "name",
      defaultValue: name,
      required: false,
    },
    {
      elementType: "input",
      label: "Designation",
      type: "Text",
      name: "designation",
      defaultValue: designation,
      required: true,
    },
    {
      elementType: "select",
      label: "Featured",
      type: "Text",
      name: "featured",
      defaultValue: featured,
      required: true,
      options: ["true", "false"],
      //.filter((item) => item !== featured)
    },
  ];

  const update = (data) => {
    updateData(`${clientsReviewApi}/${_id}`, data, true);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default ClientUniqueReview;
